<template>
  <div>
    <v-layout row wrap pt-2>
      <v-flex md4 xs12 pb-2 v-for="(birthday, i) in list" :key="i">
        <v-card :width="widthCard" height="152px" hover>
          <v-layout align-center fill-height justify-center>
            <v-flex xs4 pl-2>
              <v-img
                :src="birthday.image"
                :style="styleImg(birthday.color)"
              ></v-img>
            </v-flex>
            <v-flex xs8 pl-0 pt-3>
              <v-flex class="pl-2 font-weight-bold text-12-security text-uppercase">
                {{birthday.full_name}}
              </v-flex>
              <v-flex :class="classSubtitleCard">
                {{birthday.company}}
              </v-flex>
              <v-flex :class="classSubtitleCard">
                {{birthday.birthday}}
              </v-flex>
              <v-flex :class="classSubtitleCard">
                Anexo: {{ birthday.annexed }}
              </v-flex>
              <v-flex mt-2>
                <v-btn small round :color="birthday.color" :href="`mailto:${birthday.email}`">
                  <h3 class="white--text caption-security font-weight-regular">Enviar saludo</h3>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <infinite-loading @infinite="infiniteHandler">
        <div slot="spinner">Cargando...</div>
        <div slot="no-more" style="visibility: hidden">No hay más resultados</div>
        <v-layout slot="no-results">
          <v-flex sm12>
            <v-card height="400px">
              <v-layout align-center justify-center row wrap fill-height>
                  <v-flex sm12 class="text-29-security text-md-center font-weight-bold" style="color: #525252" v-if="monthNumber != 0">No cumpleaños este mes</v-flex>      
                  <v-flex sm12 class="text-29-security text-md-center font-weight-bold" style="color: #525252" v-else>No hay cumpleaños hoy</v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </infinite-loading>
    </v-flex>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  props: {
    date: {
      type: String,
      required: true
    },
    monthNumber: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      page: 1,
      list: [],
    };
  },
  computed: {
    widthCard() {
      if (window.innerWidth > 425) {
        return "380";
      } else {
        return "";
      }
    },
    classSubtitleCard() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return "pl-2 text-12-security"
      } else {
        return "pl-2 text-14-security"
      }
    }
  },
  methods: {
    ...mapMutations("birthdays", ["setBirthday", "setBirthdays"]),
    infiniteHandler($state) {
      let api = `${process.env.VUE_APP_API_URL}/birthdays`;
      axios.get(api, { params: { page: this.page, date: this.monthNumber } }).then(({ data }) => {
        if (data.hits.length) {
          this.page += 1;
          this.list.push(...data.hits);
          this.setBirthdays(this.list);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    styleImg(color) {
      if (this.$vuetify.breakpoint.smAndDown) {
        return `
          height: 95px; 
          width: 95px; 
          object-fit: cover; 
          border-radius: 50%; 
          border: 3.2px solid ${color}; 
          background-color: ${color}
        `
      } else {
        return `
          height: 110px; 
          width: 110px; 
          object-fit: cover; 
          border-radius: 50%; 
          border: 3.2px solid ${color}; 
          background-color: ${color}
        `
      }
    },
  }
};
</script>

<style>
</style>